import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import SearchTableStyle from "./SearchTableStyle";
import React, { useEffect } from "react";
import optionsForSearch, {
  placeHolderFromOption,
} from "../../const/searchFilterOptions";
import SelectBoxMUI from "../MUI/SelectBoxMUI/SelectBoxMUI";
import { Typography } from "@mui/material";
import "../../styles/searchInput.scss";
import {
  SearchType,
  setSearchArray,
  setSearchFilter,
} from "../../redux/slice/filterSlice";
import { useShallowSelector } from "../../hooks/useShallowSelector";
import RootState from "../../redux/types/rootState";
import { useAppDispatch } from "../../redux/dispatch/useAppDispatch";
import { fetchBookings } from "../../redux/slice/bookingSlice";

export default function SearchTable() {
  const dispatch = useAppDispatch();
  const classes = SearchTableStyle();
  const loading = useShallowSelector(
    (state: RootState) => state.bookings.isLoading
  );
  const [selectedType, setSelectedType] = React.useState<string[] | undefined>([
    "unitNumber",
  ]);

  useEffect(() => {
    if (selectedType !== undefined)
      switch (selectedType[0]) {
        case "unitNumber":
          dispatch(setSearchFilter(SearchType.UNITTYPE));
          break;
        case "iluCode":
          dispatch(setSearchFilter(SearchType.ILUCODE));
          break;
      }
  }, [selectedType]);

  const searchPlaceHolderLabel = placeHolderFromOption(
    selectedType ? selectedType[0] : ""
  );

  const handleSearch = () => {
    dispatch(fetchBookings({ page: 1 }));
  };

  return (
    <Grid container className={classes.searchBar}>
      <Grid container columnSpacing={2} className={classes.dropdownAndSearch}>
        <Grid
          alignItems="center"
          style={{ padding: 0, margin: 0 }}
          container
          item
          xs={4}
          md={4}
        >
          <Typography className={classes.commonText + " font-dfds font-bold"}>
            Search :
          </Typography>
          <Grid item xs={9} md={10}>
            <SelectBoxMUI
              name="Search"
              options={optionsForSearch}
              addLabel="Search by"
              className="font-dfds font-bold searchInput"
              selected={selectedType}
              setSelected={setSelectedType}
            />
          </Grid>
        </Grid>
        <Grid item xs={8} md={8}>
          <Box className={classes.searchIconBox}>
            <input
              className={classes.input}
              type="text"
              placeholder={searchPlaceHolderLabel ? searchPlaceHolderLabel : ""}
              onChange={(e) => {
                const inputString = e.target.value;
                const searchArray = inputString.split(/[\s,]+/).filter(Boolean);
                dispatch(setSearchArray(searchArray));
              }}
            />

            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              className={classes.searchButton}
              disabled={loading}
            >
              Search
              <SearchIcon className={classes.searchIcon} />
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
